import React, {useCallback} from 'react';

import {NumberInput} from '../../components/NumberInput';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';

const DEFAULT_STRIDE_LENGTH = 1;

export const StrideLength = () => {
  const {config, updateConfig, unsetConfigField} =
    useMediaSettingsDrawerContext();
  // underlying NumberInput handles debouncing
  const updateStrideLength = useCallback(
    (newValue?: number) => {
      const parsedValue = newValue ?? DEFAULT_STRIDE_LENGTH;
      if (parsedValue === DEFAULT_STRIDE_LENGTH) {
        // avoid storing default values in the config
        unsetConfigField('stepStrideLength');
      } else {
        updateConfig({
          stepStrideLength: parsedValue,
        });
      }
    },
    [updateConfig, unsetConfigField]
  );

  return (
    <div className="flex flex-col" data-test="step-stride-length-input">
      <SettingTitle title="Stride length" />
      <NumberInput
        className="w-full"
        placeholder="1"
        value={config.stepStrideLength}
        updateSetting={updateStrideLength}
      />
    </div>
  );
};
